// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Route, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { withApollo } from "react-apollo";
import classnames from "classnames";
import {
  SessionSpinner,
  LoginPage,
  sideMenu,
  PrivateRoute,
} from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import { SSO_RESTORE_PASS_URL } from "config";
import actions from "model/actions";
import selectors from "model/selectors";

import Nav from "containers/Nav";
import Private from "containers/Private";
import Public from "containers/Public";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./App.m.scss";

// connecting component to the redux store
@withApollo
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      loggedIn: selectors.user.loggedIn$$(state),
      sessionStatusConfirmed: selectors.user.sessionStatusConfirmed$$(state),
      requestInProgress: selectors.user.loginRequestInProgress$$(state),
      permissionsClarified: selectors.app.permissionsClarified$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    appReady: actions.app.appReady,
    logIn: actions.user.logIn,
    logOut: actions.user.logOut,
  }
)
@themr("app", styles)
export default class App extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    client: PropTypes.object,
    loggedIn: PropTypes.bool,
    sessionStatusConfirmed: PropTypes.bool,
    permissionsClarified: PropTypes.bool,
    requestInProgress: PropTypes.bool,
    // action creators:
    appReady: PropTypes.func,
    logIn: PropTypes.func,
    logOut: PropTypes.func,
  };

  logOut = () => {
    const { logOut, client } = this.props;
    logOut({ callback: client.resetStore() });
  };

  componentDidMount() {
    // telling redux we're ready for operation
    this.props.appReady();
  }

  submitLogIn = ({ username, password, setError }) => {
    this.props.logIn({ username, password, setError });
  };

  render() {
    const {
      theme,
      loggedIn,
      sessionStatusConfirmed,
      permissionsClarified,
      requestInProgress,
    } = this.props;
    return (
      <div className={classnames(theme.app)}>
        <SessionSpinner
          sessionStatusConfirmed={
            sessionStatusConfirmed && permissionsClarified
          }
        >
          <sideMenu.SideMenuController>
            <React.Fragment>
              <Nav />
              <Switch>
                <Route
                  path="/auth/login"
                  render={() =>
                    loggedIn ? (
                      <Redirect to={`/`} />
                    ) : (
                      <LoginPage
                        onSubmit={this.submitLogIn}
                        requestInProgress={requestInProgress}
                        restorePassLink={SSO_RESTORE_PASS_URL}
                      />
                    )
                  }
                />
                <Route path="/public" render={() => <Public />} />
                <PrivateRoute
                  auth={loggedIn}
                  path="*"
                  render={() => <Private />}
                />
              </Switch>
            </React.Fragment>
          </sideMenu.SideMenuController>
        </SessionSpinner>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/App.js